// import $ from "expose-loader?exposes=$,jQuery!jquery";
// require("bootstrap/dist/js/bootstrap.bundle.js");
// require("./vendors/jquery.min.js");
// require("./vendors/tether.min.js");
// require("./vendors/bootstrap.min.js");
// require("./vendors/swiper.min.js");
// require("./vendors/jquery.scrollTo.js");
require("./core/base.js");
require("./modules/theme-module.js");
// require("./bootstrapper.js");
$(() => {
  AppName.Modules.ThemeModule.init();
});
